// InfoCard.jsx
import React from "react";

export default function InfoCard({
  details,
  title,
  image,
  hod,
  hodName,

  description,
  role,
  update,
  metaData = [],
  children,
  onDelete,
  onUpdate,
}) {
  return (
    <section className="mx-auto max-w-7xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="border-b border-slate-100 p-5 sm:p-7">
      <p className="text-xs font-semibold uppercase tracking-wide text-[#1234CD]">{details}</p>
      {/* Image */}
      <div className="mt-5 flex flex-col gap-4 sm:flex-row sm:items-center">
        {image && (
          <img
            src={image}
            alt={title}
            className="h-20 w-20 rounded-full border-2 border-white object-cover shadow-sm sm:h-24 sm:w-24"
          />
        )}
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Head of department</p>
          <p className="mt-1 text-xl font-bold text-[#071C50] sm:text-2xl">{hod}</p>
          <p className="mt-1 break-all text-sm text-slate-500">{hodName}</p>
        </div>
      </div>
      </div>
      <div className="p-5 sm:p-7">
      <h2 className="text-2xl font-bold text-[#071C50] sm:text-3xl">{title}</h2>
      {description && <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 sm:text-base">{description}</p>}
      <div className="mt-6 grid gap-3 text-[#071C50] sm:grid-cols-2">
        {metaData.map((item, i) => (
          <div
            key={i}
            className="rounded-xl border border-slate-100 bg-slate-50 p-4"
          >
            <span className="block text-xs font-medium text-slate-500">{item.label}</span>
            <span className="mt-1 block font-semibold">{item.value}</span>
          </div>
        ))}
      </div>

      <div className="mt-6 w-full">{children}</div>
      {/* Buttons at bottom */}
      <div className="mt-6 flex w-full flex-col gap-3 border-t border-slate-100 pt-5 sm:flex-row">
        {onDelete && (
          <button
            onClick={onDelete}
            className="rounded-xl border border-red-200 px-4 py-2.5 text-sm font-semibold text-red-600 sm:w-48"
          >
            {role}
          </button>
        )}
        {onUpdate && (
          <button
            onClick={onUpdate}
            className="rounded-xl bg-[#1234CD] px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-800 sm:w-48"
          >
            {update}
          </button>
        )}
      </div>
      </div>
    </section>
  );
}
